package us.laantech.admin

import us.laantech.common.api.ApiEnv
import us.laantech.laanmanage.api.isRunningInDevEnv


object ENV : ApiEnv {
    // NOTE: Call back urls must be registered for each app for each user pool in the Cognito console

    // Sourced from BuildConfig (generated at build time from env vars; see build.gradle.kts)
    const val AWS_REGION = BuildConfig.AWS_REGION
    const val API_BASE_URL = BuildConfig.API_BASE_URL


    val COGNITO_BASE_URL = "cognito-idp.$AWS_REGION.amazonaws.com"
    const val COGNITO_CLIENT_ID = BuildConfig.COGNITO_CLIENT_ID
    const val COGNITO_USER_POOL_ID = BuildConfig.COGNITO_USER_POOL_ID

    // Used to decide locally whether a refresh token is still worth using (silent
    // refresh on app start / on 401). Must match the Cognito app client's configured
    // refresh-token expiration.
    const val COGNITO_REFRESH_TOKEN_VALIDITY_SECONDS = 30L * 24 * 60 * 60 // 30 days


    private const val LOCALHOST = "http://localhost:8081"
    private const val TEST_URL = BuildConfig.CALLBACK_URL

    // Adjust above values, most likely the values below this line will not change

    val COGNITO_CALLBACK_URL = if (isRunningInDevEnv()) LOCALHOST else TEST_URL

    val COGNITO_POOL_BASE_URL = "https://${COGNITO_USER_POOL_ID.replace("_", "")}.auth.$AWS_REGION.amazoncognito.com"

    val COGNITO_LOGIN_PAGE = "$COGNITO_POOL_BASE_URL/login?response_type=code&client_id=$COGNITO_CLIENT_ID&redirect_uri=$COGNITO_CALLBACK_URL"
    val COGNITO_TOKEN_ENDPOINT = "$COGNITO_POOL_BASE_URL/oauth2/token"

    const val COGNITO_IOS_CALLBACK_URL = "laanmanage://callback"
    val COGNITO_IOS_LOGIN_PAGE = "$COGNITO_POOL_BASE_URL/login?response_type=code&client_id=$COGNITO_CLIENT_ID&redirect_uri=$COGNITO_IOS_CALLBACK_URL"

    // ApiEnv: what the shared us.laantech.common.api.KtorClient needs (configured in AppViewModel).
    override val apiBaseUrl: String =
        if (isRunningInDevEnv()) "http://localhost:8080" else "https://$API_BASE_URL"
    override val cognitoClientId: String get() = COGNITO_CLIENT_ID
    override val cognitoTokenEndpoint: String get() = COGNITO_TOKEN_ENDPOINT
    override val cognitoCallbackUrl: String get() = COGNITO_CALLBACK_URL
    override val refreshTokenValiditySeconds: Long get() = COGNITO_REFRESH_TOKEN_VALIDITY_SECONDS
}